import styled from 'styled-components'
import { Link } from 'react-router-dom'
import ScheduleGridService from 'services/ScheduleGrid'

const cellWidth = 60
const cellHeight = 26

export const Container = styled.div`
  width: calc(100vw - 380px);
  display: flex;
  flex-direction: column;
  position: relative;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

export const GridHeader = styled.div`
  display: grid;
  background-color: #FFFFFF;
  grid-template-columns: repeat(${({ numColumns }) => numColumns}, 1fr);
  justify-items: center;
  align-items: flex-start;
  position: sticky;
  top: 15px;
  z-index: 3;
  margin-bottom: 3px;
  padding-left: 60px;
  gap: 5px;

  &:before,
  &:after {
    content: '';
    background-color: #ffffff;
    position: absolute;
    width: 10px;
    height: 100%;
  }

  &:before {
    left: -10px;
    width: 40px;
  }

  &:after {
    right: -10px;
  }
`

export const ScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ numColumns }) => numColumns}, minmax(${cellWidth}px, 1fr));
  background-color: transparent;
  justify-content: center;
  align-items: flex-start;
  padding-left: 60px;
  column-gap: 3px;
`

export const ProfessionalColumn = styled.div`
  display: grid;
  position: relative;
  grid-template-columns: ${({ schedules, timeWindows, professional, timeInterval }) => {
    const numConflictingSchedules = ScheduleGridService.getNumConflictingSchedules (
      schedules, timeWindows, professional?.time_interval || timeInterval
    )
    return `repeat(${numConflictingSchedules}, calc(100% / ${numConflictingSchedules}))`
  }};
  grid-template-rows: ${({ numRows, professional, timeInterval }) => (
    `repeat(${numRows}, ${cellHeight * ((professional?.time_interval || timeInterval) / timeInterval)}px)`
  )};
  background-color: transparent;
  padding: 0px;
`

export const GridColumn = styled.div`
  width: 100%;
  position: absolute;
  display: grid;
  grid-template-rows: ${({ numRows, professional, timeInterval }) => (
    `repeat(${numRows}, ${cellHeight * ((professional?.time_interval || timeInterval) / timeInterval)}px)`
  )};
`

export const TimeMark = styled.div`
  width: 100%;
  display: block;
  background-color: transparent;
  border-top: 1px solid #CCCCCC;

  &:before {
    content: '${({ label }) => label}';
    color: #000000;
    font-size: 12px;
    font-weight: bold;
    position: absolute;
    left: 0px;
    margin-top: 1px;
    margin-left: 5px;
  }
`

export const HorizontalLine = styled.div`
  width: calc(100% + 6px);
  display: block;
  background-color: transparent;
  border-top: 1px solid #CCCCCC;
  margin-left: -3px;
`

export const SelectBox = styled.div`
  display: flex;
  border-radius: 10px;
  cursor: pointer;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 5px;
`

export const SubTitle = styled(InfoText)`
  font-weight: 500;
  line-height: 16px;
  margin: 0;
`

export const LinkText = styled(Link)`
  color: #35A7FF;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: #2875E2;
  }
`
